import axios from "axios";
import store from './../index'

// «Отчёты → Отчёты продаж» (перенос страницы control SalesReports, роли Manager и Programmer):
// карточка 1 — Ad/GetAdClickByContentExcelReportAsync, остальные — SalesReports/*.
// Все выгрузки — xlsx; ошибка валидации приходит как 400 { error } внутри blob.

async function downloadXlsx(request, fileName) {
  try {
    const { data } = await request();

    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    let text = 'Не удалось сформировать отчёт';
    try {
      const body = error.response?.data;
      if (body instanceof Blob) {
        text = JSON.parse(await body.text()).error || text;
      } else if (body?.error) {
        text = body.error;
      }
    } catch (parseError) {
      window.console.log(parseError);
    }
    store.commit('SET_SNACKBAR', { text, timeout: 7500, color: 'error', linkText: '', show: true });
    throw error;
  }
}

function post(url, payload, fileName) {
  return downloadXlsx(() => axios.post(url, payload || {}, { responseType: 'blob' }), fileName);
}

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // Зоны (Id = AdLocation) и баннеры с зоной и товаром
    SALES_REPORTS_FILTER_OPTIONS: async () => {
      const { data } = await axios.get('/SalesReports/GetFilterOptionsAsync');

      return data;
    },

    DOWNLOAD_SALES_REPORTS_AD_CLICKS: (_, search) =>
      post('/Ad/GetAdClickByContentExcelReportAsync', search, 'Клики на баннеры.xlsx'),

    DOWNLOAD_SALES_REPORTS_ALTERNATIVE_CLICKS: (_, search) =>
      post('/SalesReports/DownloadAlternativeClicksAsync', search, 'Альтернатива.xlsx'),

    DOWNLOAD_SALES_REPORTS_PROMO_CLICKS: (_, search) =>
      post('/SalesReports/DownloadPromoClicksAsync', search, 'Товар дня-Акция-Товар месяца.xlsx'),

    DOWNLOAD_SALES_REPORTS_ALL_BANNERS_CLICKS: (_, period) =>
      post('/SalesReports/DownloadAllBannersClicksAsync', period, 'Клики по всем баннерам.xlsx'),

    DOWNLOAD_SALES_REPORTS_BANNER_TYPES_CLICKS: (_, period) =>
      post('/SalesReports/DownloadBannerTypesClicksAsync', period, 'Клики по баннерам всех типов.xlsx'),
  },
}
